import { gql } from "@apollo/client";

export default gql`
  query GetOrderPdf($eorderId: String!, $id: Int!) {
    getPdf(eorderId: $eorderId, id: $id)
  }
`;
